import { render, staticRenderFns } from "./OrdersChangeStatus.vue?vue&type=template&id=9756f712&scoped=true&"
import script from "./OrdersChangeStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrdersChangeStatus.vue?vue&type=style&index=0&id=9756f712&lang=scss&scoped=true&"
import style1 from "./OrdersChangeStatus.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9756f712",
  null
  
)

export default component.exports